import { atom, atomFamily, selectorFamily } from 'recoil';
import trimAllSpaces from 'utils/text/trimAllSpaces';
export const vehicleFormIdsToRegister = atom({
  key: 'vehicleFormIdsToRegister',
  default: []
});
export const vehiclesToRegister = atom({
  key: 'vehiclesToRegister',
  default: []
});
export const vehicleFormValid = atomFamily({
  key: 'vehicleFormValid',
  default: false
});
export const vehicleFormsToRegisterValid = atom({
  key: 'vehicleFormsToRegisterValid',
  default: []
});
export const registeredVehicle = atom({
  key: 'registeredVehicle',
  default: null
});
export const getSelectedVehicle = selectorFamily({
  key: 'getSelectedVehicle',
  get: registrationNumber => ({
    get
  }) => {
    const vehicles = get(vehiclesToRegister);
    return vehicles.find(v => trimAllSpaces(v?.registrationNumber) === trimAllSpaces(registrationNumber));
  }
});